/** Shared client-side skill artifact upload: presign a PUT URL, then upload the file.
 * Used by both the new-skill submission flow and the submit-new-version flow. */

export function contentTypeFor(file: File): string {
  if (file.type) return file.type;
  return file.name.toLowerCase().endsWith(".zip") ? "application/zip" : "application/octet-stream";
}

async function presign(file: File): Promise<{ url: string; key: string }> {
  const res = await fetch("/api/files/presign", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      filename: file.name,
      contentType: contentTypeFor(file),
      size: file.size,
    }),
  });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(typeof j.error === "string" ? j.error : "Could not prepare upload");
  }
  return res.json();
}

/** Presign + PUT the file to storage. Returns the stored artifact key. */
export async function uploadArtifact(file: File): Promise<string> {
  const { url, key } = await presign(file);
  const put = await fetch(url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": contentTypeFor(file) },
  });
  if (!put.ok) throw new Error("Upload failed");
  return key;
}
